import { FEATURE_FLAG } from '~/constants/feature-flags.constants'
import isFlagOn from '~/composables/feature-flag'

const INTERNAL_EMAIL_DOMAIN = 'compareclub.com.au'

/**
 * CLUB-949: AI Advisor (OTTO) is visible when EITHER the `feature_AIAdvisor`
 * Split.io flag is on OR the signed-in member's email is on the Compare Club
 * domain, so staff can test it in production before the flag is switched on
 * for the public.
 */

/**
 * @param {string|null|undefined} email
 * @returns {boolean} true when the email belongs to the compareclub.com.au domain
 */
export function isInternalEmail (email) {
  if (typeof email !== 'string') return false
  const domain = email.trim().toLowerCase().split('@')[1]
  return domain === INTERNAL_EMAIL_DOMAIN
}

/**
 * Resolves whether the current member may see / open AI Advisor.
 * Client-only; defaults to false on any SDK error or timeout.
 * @returns {Promise<boolean>}
 */
export function isAIAdvisorAvailable () {
  if (import.meta.server) return Promise.resolve(false)
  const userStore = useUserStore()
  if (isInternalEmail(userStore.getUserProfile?.email)) return Promise.resolve(true)
  return isFlagOn(FEATURE_FLAG.aiAdvisor)
}
